import styled from '@emotion/styled';
import { rem } from '@utils';

const Wrapper = styled.div`
  position: relative;
`;

const Button = styled.button<{ selected: boolean }>(
  ({ selected, theme }) => `
  background: ${
    selected ? theme.palette.primary.dark : theme.palette.common.white
  };
  border: 1px solid ${
    selected ? theme.palette.primary.dark : theme.palette.grey['500']
  };
  border-radius: 4px;
  color: ${selected ? theme.palette.common.white : theme.palette.common.black};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  padding: ${rem(8)};
  width: ${rem(32)};
  height: ${rem(32)};
  transition: 100ms ease;

  &[disabled] {
    border-color: ${theme.palette.grey['400']};
    color: ${theme.palette.grey['400']};
    cursor: not-allowed;
  }

  &:hover:not([disabled]) {
    border-color: ${
      selected ? theme.palette.primary.dark : theme.palette.primary.main
    };
    color: ${
      selected ? theme.palette.common.white : theme.palette.primary.main
    };
  }
`
);

const Menu = styled.menu`
  background: ${({ theme }) => theme.palette.common.white};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.grey['200']};
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.08);
  max-width: var(--prompt-menu-max-width);
  padding: ${rem(8)};
  position: absolute;
  bottom: calc(100% + ${rem(8)});
  left: 0;
  z-index: 1;
  width: max-content;
`;

const MenuItem = styled.li<{ disabled?: boolean }>(
  ({ disabled, theme }) => `
  border-radius: 4px;
  color: ${disabled ? theme.palette.grey['400'] : theme.palette.common.black};
  cursor: ${disabled ? 'not-allowed' : 'pointer'};
  display: flex;
  gap: ${rem(8)};
  font-weight: 500;
  padding: ${rem(12)} ${rem(8)};
  transition: 100ms ease;

  &:hover {
    background: ${disabled ? 'transparent' : theme.palette.pink.bg};
    color: ${disabled ? theme.palette.grey['400'] : theme.palette.primary.dark};
  }
`
);

const WidgetSlot = styled.div<{ placement: 'above' | 'below'; width: string }>(
  ({ placement, width }) => `
  position: absolute;
  left: 0;
  ${
    placement === 'below'
      ? `top: calc(100% + ${rem(8)});`
      : `bottom: calc(100% + ${rem(8)});`
  }
  width: ${width || '100%'};
  z-index: 1;
`
);

export default {
  Wrapper,
  Button,
  Menu,
  MenuItem,
  WidgetSlot
};
